import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">{t('about_title')}</h2>
          </div>
          <div className="lg:col-span-2 space-y-4 text-sm md:text-base leading-relaxed text-foreground-600">
            <p>{t('about_p1')}</p>
            <p>{t('about_p2')}</p>
            <p>{t('about_p3')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}